import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export function SlotReel({ items }: { items: string[] }) {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setI((n) => (n + 1) % items.length), 75);
    return () => clearInterval(t);
  }, [items]);
  const label = items[i] || "…";
  return (
    <div className="relative flex h-24 w-full max-w-sm items-center justify-center overflow-hidden rounded-2xl border-[4px] border-ink bg-ink px-4" data-testid="slot-reel-anim">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-6 bg-gradient-to-b from-ink to-transparent z-10" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-6 bg-gradient-to-t from-ink to-transparent z-10" />
      <motion.span key={i} initial={{ y: -36, opacity: 0.4 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.07 }}
        className="truncate font-display text-2xl font-bold uppercase text-pop-yellow sm:text-3xl">
        {label}
      </motion.span>
    </div>
  );
}
